<div class="datepicker" (click)="openDatepicker()">
  <input
    type="text"
    class="datepicker__input tp-control"
    [class.datepicker__input--with-label]="innerLabel"
    [matDatepicker]="datepicker"
    [value]="selectedDate"
    (dateChange)="onDateChange($event)"
    [min]="minDate"
    [max]="maxDate"
    readonly
  />

  <div *ngIf="innerLabel" class="datepicker__inner-label">{{ innerLabel }}</div>

  <mat-datepicker-toggle class="datepicker__toggle" [for]="datepicker">
    <tp-icon
      class="datepicker__trigger-icon"
      name="icons/calendar"
      matDatepickerToggleIcon
    ></tp-icon>
  </mat-datepicker-toggle>

  <mat-datepicker #datepicker [touchUi]="isMobileView$ | async"></mat-datepicker>
</div>
